import { createResourceSlice, resourceInitialState } from 'store/ResourceSlice';
import { RoomTypeState } from 'typings/state';

export const initialState: RoomTypeState = resourceInitialState();

const slice = createResourceSlice({
    name: 'roomType',
    initialState,
});

export const roomType = slice.reducer;
export const actions: typeof slice.actions = slice.actions;
